
    import '/mnt/src/components/Tabs/index.md?watch=parent';
    export const demoIndex = {
  ids: ["tabs-demo-basicdemo","tabs-demo-styledemo","tabs-demo-text-style","tabs-demo-custom-color"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tabs/index.md?type=demo')
};